import '@mdi/font/css/materialdesignicons.css'

import 'vuetify/styles'
// import '../assets/main.scss'

import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { md3 } from 'vuetify/blueprints'

import { createVueI18nAdapter } from 'vuetify/locale/adapters/vue-i18n'
import { useI18n } from 'vue-i18n'
import i18n from '@/i18n/i18n-setup'

const HypatiaLearningLightTheme = {
  dark: false,
  colors: {
    background: '#ffffff',
    surface: '#ffffff',
    primary: '#05a79e',
    'primary-darken-1': '#2eb3ac',
    secondary: '#56bfb9',
    'secondary-darken-1': '#a8d8d4',
    error: '#ff4747',
    info: '#ffe599',
    success: '#00b787',
    warning: '#ffdd00',
    text: '#ffffff'
  }
}

const vuetify = createVuetify({
  components,
  directives,
  ssr: true,
  iconfont: 'mdi',
  blueprint: md3,
  locale: {
    adapter: createVueI18nAdapter({ i18n, useI18n })
  },
  theme: {
    defaultTheme: 'HypatiaLearningLightTheme',
    themes: {
      HypatiaLearningLightTheme
    }
  }
})

export default vuetify
